export const GENERIC_EMAIL_DOMAINS = [
  "gmail",
  "outlook",
  "hotmail",
  "live",
  "free",
  "orange",
  "icloud",
  "neuf",
  "wanadoo",
  "laposte",
  "yahoo"
];
